import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styles: [
    '.w-100 {width:100px !important};'
  ]
})
export class TimepickerComponent implements OnInit {
  @Input() inpHour: any;
  @Input() inpMin: any;
  @Input() IsRequired: any;
  @Output() changeTime = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();
  hour: FormControl = new FormControl('', [Validators.pattern('([01]?[0-9]|2[0-3])')]);
  errMess: string;
  ;
  min: FormControl = new FormControl('', [Validators.pattern('[0-5]?[0-9]?$')]);

  constructor() { }

  ngOnInit(): void {
    if (this.IsRequired) {
      this.hour.setValidators([Validators.required, Validators.pattern('([01]?[0-9]|2[0-3])')]);
      this.min.setValidators([Validators.required, Validators.pattern('[0-5]?[0-9]?$')]);
    }
    this.hour.setValue(this.inpHour ? this.inpHour : '');
    this.min.setValue(this.min ? this.inpMin : '');
  }
  onChange(e, type) {
    if (type == 1) {
      this.hour.setValue(e.target.value ? e.target.value.toString() : '');
    }
    if (type == 2) {
      this.min.setValue(e.target.value ? e.target.value.toString() : '');
    }

    if (!this.hour.errors && !this.min.errors) {
      this.errMess = '';
      // nếu xóa đi hoặc rỗng thì trả về giá trị null
      if (!this.hour.value || this.hour.value == '' || !this.min.value || this.min.value == '') {
        this.changeTime.emit({ err: 1, isDeleted: true });
      } else {
        this.changeTime.emit(this.hour.value + ':' + this.min.value)

      }
    } else {
      if (this.hour.errors?.required || this.min.errors?.required) {
        this.errMess = 'gioIsRequired';
      }

      if (this.hour.errors?.pattern || this.min.errors?.pattern) {
        this.errMess = 'Giờ không hợp lệ';
      }
      if (this.hour.errors) {
        this.hour.setValue('');
      }
      if (this.min.errors) {
        this.min.setValue('');
      }
      this.changeTime.emit({ err: this.errMess });
    }
  }
}
